import type { EntityConfig } from '../types'

export const campaignEntity: EntityConfig = {
  id: 'campaign',
  displayName: 'Campaign',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'draft', label: 'Draft' },
      { value: 'scheduled', label: 'Scheduled' },
      { value: 'active', label: 'Active' },
      { value: 'paused', label: 'Paused' },
      { value: 'completed', label: 'Completed' },
      { value: 'archived', label: 'Archived' },
    ],
    options: [
      { value: 'draft', label: 'Draft', color: 'neutral' },
      { value: 'scheduled', label: 'Scheduled', color: 'info' },
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'paused', label: 'Paused', color: 'warning' },
      { value: 'completed', label: 'Completed', color: 'neutral' },
      { value: 'archived', label: 'Archived', color: 'neutral' },
    ],
    mappings: {
      all: ['draft', 'scheduled', 'active', 'paused', 'completed', 'archived'],
      active: ['active'],
      draft: ['draft'],
      scheduled: ['scheduled'],
      paused: ['paused'],
      completed: ['completed'],
      archived: ['archived'],
    },
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    objective: { type: 'string_array', urlKey: 'objective' },
    rewardMechanic: { type: 'string_array', urlKey: 'rewardMechanic' },
    dateRange: { type: 'date_range', urlKey: 'dateRange' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['status', 'objective', 'rewardMechanic', 'dateRange'],
}
